const JiraTypes = Object.freeze({
  JIRA_PROJECTS: 'JIRA_PROJECTS',
  JIRA_PROJECTS_UPDATE: 'JIRA_PROJECTS_UPDATE',
  JIRA_PROJECT_ISSUES: 'JIRA_PROJECT_ISSUES',
  JIRA_ISSUES: 'JIRA_ISSUES',
  JIRA_ISSUES_SEARCH: 'JIRA_ISSUES_SEARCH',
  JIRA_ISSUE_DATA: 'JIRA_ISSUE_DATA',
  JIRA_PROJECTS_PUSH_UPDATE: 'JIRA_PROJECTS_PUSH_UPDATE',
  JIRA_PROJECTS_RESET_ENTITIES: 'JIRA_PROJECTS_RESET_ENTITIES'
});

export default JiraTypes;
